export default __webpack_public_path__ + "static/media/54t.b79690be.jpg";